import { FC } from 'react';

import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

import Button from '@mui/material/Button';
import DialogContentText from '@mui/material/DialogContentText';

import { Dialog } from '@xlrt/components';
import { useDeleteDialogStyles } from './styles/delete-conversation-dialog.styles';
import { mcpChatTranslationRef } from '../../translation';

interface DeleteConversationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConversationDialog: FC<DeleteConversationDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const classes = useDeleteDialogStyles();
  const { t } = useTranslationRef(mcpChatTranslationRef);

  return (
    <Dialog
      className={classes.removeConversationDialog}
      title={t('deleteConversationDialog.title')}
      titleClass={classes.removeConversationDialogTitle}
      open={open}
      handleClose={onClose}
      dividers={false}
      fullWidth={false}
      PaperProps={{
        className: classes.dialogPaper,
      }}
      actionsClass={classes.removeConversationDialogActions}
      closeButtonClass={classes.removeConversationDialogCloseBtn}
      dialogActions={
        <>
          <Button
            className={classes.removeConversationDialogBtn}
            onClick={onClose}
            variant="outlined"
          >
            {t('deleteConversationDialog.cancel')}
          </Button>
          <Button
            className={`${classes.removeConversationDialogBtn} ${classes.removeConversationDialogBtnDelete}`}
            onClick={onConfirm}
            variant="contained"
          >
            {t('deleteConversationDialog.confirm')}
          </Button>
        </>
      }
    >
      <DialogContentText className={classes.removeConversationDialogContent}>
        {t('deleteConversationDialog.content')}
      </DialogContentText>
    </Dialog>
  );
};
